<template>
    <div>
        <div class="row mb-3">
            <div class="col-lg-6">
                <label for="">Tipo *</label>
                <select class="form-control" v-model="Vacacion.Tipo">
                    <option value="">Seleccione una Opción</option>
                    <option value="1">Vacación</option>
                    <option value="2">Permiso con Paga</option>
                    <option value="3">Permiso sin Paga</option>
                    <option value="4">Licencia</option>
                </select>
            </div>
        </div>
        <div class="row mb-3" v-show="Vacacion.Tipo=='1' || Vacacion.Tipo=='4'"	>
            <div class="col-lg-6">
                <label for="">Fecha Inicio *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="Vacacion.FechaInicio" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
                <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaInicio" :Mensaje="this.errorvalidacion.FechaInicio[0]"></Cvalidation></label>
            </div>
            <div class="col-lg-6">
                <label for="">Fecha Fin *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="Vacacion.FechaFin" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
            </div>
        </div>
		<div class="row mb-3" v-show="Vacacion.Tipo=='2' || Vacacion.Tipo=='3'">
			<div class="col-lg-6">
                <label for="">Fecha *</label>
                <v-date-picker v-model="Vacacion.FechaInicio" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
                <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaInicio" :Mensaje="this.errorvalidacion.FechaInicio[0]"></Cvalidation></label>
            </div>
		</div>
		<div class="row mb-3" v-show="Vacacion.Tipo=='2' || Vacacion.Tipo=='3'">
			<div class="col-lg-6">
				<label for="">Hora Inicio</label>
				<div class="row">
					<div class="col-lg-6">
						<select name="" id="" v-model="Vacacion.HoraInicio" class="form-control form-control-sm mr-0 pr-0">
							<option v-for="n in 25" :key="n" :value="n-1<10 ? '0'+Number(n-1) : n-1">{{ n-1<10 ? '0'+Number(n-1) : n-1 }}</option>
						</select>
					</div>
					<div class="col-lg-6">
						<select name="" id="" v-model="Vacacion.MinutoInicio" class="form-control form-control-sm mr-0 pr-0">
							<option v-for="n in 60" :key="n" :value="n-1<10 ? '0'+Number(n-1) : n-1">{{ n-1<10 ? '0'+Number(n-1) : n-1 }}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="col-lg-6">
				<label for="">Hora Fin</label>
				<div class="row">
					<div class="col-lg-6">
						<select name="" id="" v-model="Vacacion.HoraFin" class="form-control form-control-sm mr-0 pr-0">
							<option v-for="n in 25" :key="n" :value="n-1<10 ? '0'+Number(n-1) : n-1">{{ n-1<10 ? '0'+Number(n-1) : n-1 }}</option>
						</select>
					</div>
					<div class="col-lg-6">
						<select name="" id="" v-model="Vacacion.MinutoFin" class="form-control form-control-sm mr-0 pr-0">
							<option v-for="n in 60" :key="n" :value="n-1<10 ? '0'+Number(n-1) : n-1">{{ n-1<10 ? '0'+Number(n-1) : n-1 }}</option>
						</select>
					</div>
				</div>
			</div>
		</div>
        <div class="row mb-3">
            <div class="col-lg-12">
                <label for="">Archivo</label>
                <div class="custom-file-input-image">
                    <input @change="SubirArchivo()" type="file" accept="application/pdf" ref="file" class="custom-file-input" id="validatedCustomFile" required>
                    <input type="text" v-model="Archivo" class="form-control">
                    <button type="button" class=""><i class="fas fa-paperclip"></i></button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <label for="">Comentario</label>
                <textarea class="form-control" v-model="Vacacion.Comentario" cols="10" rows="10"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Vacacion",
    props:["poBtnSave"],
    data() {
        return {
            Modal:true,
            FormName:'Vacacion',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            Vacacion:{
                IdVacacion:0,
                IdTrabajador:0,
                FechaInicio:'',
                FechaFin:'',
                Comentario:'',
                Archivo:'',
                Tipo:'',
				HoraInicio:'',
				MinutoInicio:'',
				HoraFin:'',
				MinutoFin:''
            },
            Archivo:'Elegir Archivo (0.5MB)',
            errorvalidacion:[]
        }
    },
    methods: {
        Guardar(){
            this.errorvalidacion=[];
            let FechaInicio='';
            if (this.Vacacion.FechaInicio!='' && this.Vacacion.FechaInicio!=undefined) {
                let day=this.Vacacion.FechaInicio.getDate();
                let month=this.Vacacion.FechaInicio.getMonth()+1;
                let year=this.Vacacion.FechaInicio.getFullYear();
                FechaInicio=year+'-'+month+'-'+day;   
            }
            let FechaFin='';
            if (this.Vacacion.FechaFin!='' && this.Vacacion.FechaFin!=undefined) {
                let day=this.Vacacion.FechaFin.getDate();
                let month=this.Vacacion.FechaFin.getMonth()+1;
                let year=this.Vacacion.FechaFin.getFullYear();
                FechaFin=year+'-'+month+'-'+day;   
            }
            let file = this.$refs.file.files[0];
            let formData=new FormData();
            formData.set('IdVacacion',this.Vacacion.IdVacacion);
            formData.set('Tipo',this.Vacacion.Tipo);
            formData.set('IdTrabajador',this.Vacacion.IdTrabajador);
            formData.set('Comentario',this.Vacacion.Comentario);
            formData.set('FechaInicio',FechaInicio);
            formData.set('FechaFin',FechaFin);
            formData.set('NombreArchivo',this.Vacacion.Archivo);
            formData.append('NombreArchivoFile',file);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vacacion/post',formData,{
                headers:{
                    'Content-Type':'multipart/form-data'
                }
            }).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Vacacion").modal("hide");
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
        Limpiar(){
            const  input  = this.$refs.file;
            input .type = 'text'
            input .type = 'file';
            this.Vacacion={
                IdVacacion:0,
                IdTrabajador:0,
                Tipo:'',
                FechaInicio:new Date(),
                FechaFin:new Date(),
                Comentario:'',
                Archivo:'',
				HoraInicio:'',
				MinutoInicio:'',
				HoraFin:'',
				MinutoFin:''
            }
            // if (localStorage.getItem("fechacalendario")) {
			// 	let NuevaFecha = localStorage.getItem("fechacalendario");
			// 	let formatedDate = NuevaFecha.replace(/-/g, "\/");
			// 	this.Vacacion.FechaInicio = new Date(formatedDate);
            //     this.Vacacion.FechaFin = new Date(formatedDate);
			// }
            this.Archivo='Elegir Archivo (0.5MB)';
            this.errorvalidacion=[];
        },
        Recuperar(){
            this.$http.get('vacacion/recovery',{
                params:{
                    IdVacacion:this.Vacacion.IdVacacion
                }
            }).then((res)=>{
                const objres=res.data.data.vacacion;
                this.Vacacion.IdVacacion=objres.IdVacacion;
                this.Vacacion.Tipo=objres.Tipo;
                this.Vacacion.IdTrabajador=objres.IdTrabajador;
                let formatedDateInicio = objres.FechaInicio.replace(/-/g, "\/");
                this.Vacacion.FechaInicio=new Date(formatedDateInicio);
                let formatedDateFin = objres.FechaFin.replace(/-/g, "\/");
                this.Vacacion.FechaFin=new Date(formatedDateFin);
                this.Vacacion.Archivo=objres.Archivo;
                this.Vacacion.Comentario=objres.Comentario;
                this.Archivo=objres.Archivo;
            })
        },
        SubirArchivo(){
            const image = this.$refs.file.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extensiones permitidas .pdf');
                const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='Elegir archivo (0.5MB)';
                return false;
            }

            this.Archivo=image.name;
        }
    },
    created() {
        this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdTrabajador)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdTrabajador!==undefined) {
                this.Vacacion.IdTrabajador=IdTrabajador;
            }
            if (Id > 0) {
				this.Vacacion.IdVacacion = Id;
				this.Recuperar();
			}
        });
    },
    computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
